.bg{aspect-ratio:1/1;}